(function () {
  'use strict';

  var INDEX = null;
  var indexPromise = null;
  var HEADING = 'Guides & ingredients';

  var SECTION_LABELS = {
    ingredient: 'Ingredients',
    health_benefit: 'Health benefits',
    health_category: 'Health categories',
    mood: 'Mood profiles',
    taste: 'Taste profiles',
    aroma: 'Aroma profiles',
    tea_type: 'Tea types',
    hub: 'Guides',
  };

  var SECTION_ORDER = [
    'ingredient',
    'mood',
    'taste',
    'aroma',
    'tea_type',
    'hub',
  ];

  var SIDEBAR_HUB_TYPES = {
    health_benefit: true,
    health_category: true,
  };

  function indexFromScriptTag() {
    var el = document.getElementById('teavity-hub-search-index-data');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function loadIndex() {
    if (INDEX) return Promise.resolve(INDEX);
    if (indexPromise) return indexPromise;

    var inline = indexFromScriptTag();
    if (inline && inline.entries) {
      INDEX = inline;
      return Promise.resolve(INDEX);
    }

    var url = (window.TeavityHubSearch && window.TeavityHubSearch.indexUrl) || '';
    if (!url) {
      var indexScript = document.getElementById('teavity-hub-search-index-data');
      if (indexScript && indexScript.src) url = indexScript.src;
    }
    if (!url) {
      var link = document.querySelector('link[href*="teavity-hub-search-index"]');
      if (link) url = link.href;
    }
    if (!url) {
      return Promise.resolve({ entries: [] });
    }

    indexPromise = fetch(url)
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        INDEX = data;
        return INDEX;
      })
      .catch(function () {
        INDEX = { entries: [] };
        return INDEX;
      });

    return indexPromise;
  }

  function normalize(text) {
    return String(text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s-]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function searchHubs(query, limit) {
    limit = limit || 8;
    if (!INDEX || !INDEX.entries) return [];

    var q = normalize(query);
    if (!q || q.length < 2) return [];

    var terms = q.split(' ').filter(Boolean);
    var scored = [];

    INDEX.entries.forEach(function (entry) {
      var parts = [entry.title, entry.handle, entry.description || ''];
      (entry.keywords || []).forEach(function (k) {
        parts.push(k);
      });
      var hay = normalize(parts.join(' '));
      var score = 0;

      if (hay.indexOf(q) !== -1) score += 12;
      if (normalize(entry.handle).indexOf(q) !== -1) score += 8;
      if (normalize(entry.title).indexOf(q) !== -1) score += 6;

      terms.forEach(function (term) {
        if (term.length < 2) return;
        if (hay.indexOf(term) !== -1) score += 3;
      });

      if (score > 0) {
        scored.push({ entry: entry, score: score });
      }
    });

    scored.sort(function (a, b) {
      return b.score - a.score;
    });

    return scored.slice(0, limit).map(function (item) {
      return item.entry;
    });
  }

  function escapeHtml(text) {
    return String(text || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function imageSrc(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=480';
  }

  function renderSearchCard(entry) {
    var title = entry.title || '';
    var typeLabel = entry.typeLabel || entry.type || 'Guide';
    var mediaHtml = '';

    if (entry.image) {
      mediaHtml =
        '<img class="teavity-search-card__image" src="' +
        escapeHtml(imageSrc(entry.image)) +
        '" alt="' +
        escapeHtml(entry.imageAlt || title) +
        '" loading="lazy" width="560" height="560">';
    } else {
      mediaHtml =
        '<span class="teavity-search-card__placeholder" aria-hidden="true">' +
        escapeHtml(title.charAt(0).toUpperCase() || '?') +
        '</span>';
    }

    var descHtml = '';
    if (entry.description) {
      descHtml =
        '<p class="teavity-search-card__desc">' + escapeHtml(entry.description) + '</p>';
    }

    return (
      '<a href="' +
      escapeHtml(entry.url) +
      '" class="teavity-search-card no-underline" aria-label="' +
      escapeHtml(title) +
      '">' +
      '<div class="teavity-search-card__media">' +
      '<span class="teavity-search-card__badge">' +
      escapeHtml(typeLabel) +
      '</span>' +
      mediaHtml +
      '</div>' +
      '<div class="teavity-search-card__body">' +
      '<h3 class="teavity-search-card__title">' +
      escapeHtml(title) +
      '</h3>' +
      descHtml +
      '</div>' +
      '</a>'
    );
  }

  function partitionResults(results) {
    var main = [];
    var sidebar = [];
    results.forEach(function (entry) {
      if (SIDEBAR_HUB_TYPES[entry.type]) sidebar.push(entry);
      else main.push(entry);
    });
    return { main: main, sidebar: sidebar };
  }

  function renderListItem(entry) {
    var metaHtml = '';
    if (entry.description) {
      metaHtml =
        '<span class="teavity-search-list__meta">' +
        escapeHtml(entry.description) +
        '</span>';
    }
    return (
      '<li class="teavity-search-list__item">' +
      '<a href="' +
      escapeHtml(entry.url) +
      '" class="teavity-search-list__link no-underline">' +
      '<span class="teavity-search-list__title">' +
      escapeHtml(entry.title) +
      '</span>' +
      metaHtml +
      '</a></li>'
    );
  }

  function renderSidebarHubSection(entries) {
    if (!entries.length) return '';
    var html =
      '<section class="teavity-search-sidebar-section teavity-predictive-search__section">' +
      '<h2 class="teavity-search-sidebar-section__title">Health benefits</h2>' +
      '<ul class="teavity-search-list">';
    entries.forEach(function (entry) {
      html += renderListItem(entry);
    });
    html += '</ul></section>';
    return html;
  }

  function updateSearchLayout() {
    var layout = document.querySelector('.teavity-search-layout');
    var sidebar = document.getElementById('teavity-search-sidebar');
    if (!layout || !sidebar) return;

    var hasArticles = !!document.querySelector(
      '#teavity-search-sidebar > .teavity-search-sidebar-section'
    );
    var hasPages = !!document.querySelector(
      '#teavity-search-sidebar .teavity-search-list'
    );
    var hubSidebar = document.getElementById('teavity-hub-search-sidebar');
    var hasHealth =
      hubSidebar &&
      !hubSidebar.hasAttribute('hidden') &&
      hubSidebar.innerHTML.trim().length > 0;

    var showSidebar = hasArticles || hasPages || hasHealth;
    layout.classList.toggle('teavity-search-layout--full', !showSidebar);
    sidebar.hidden = !showSidebar;
  }

  function groupResultsByType(results) {
    var groups = {};
    results.forEach(function (entry) {
      var type = entry.type || 'hub';
      if (!groups[type]) groups[type] = [];
      groups[type].push(entry);
    });
    return SECTION_ORDER.filter(function (type) {
      return groups[type] && groups[type].length;
    }).map(function (type) {
      return {
        type: type,
        label: SECTION_LABELS[type] || type,
        entries: groups[type],
      };
    });
  }

  function renderHubCard(entry) {
    return renderSearchCard(entry);
  }

  function renderHubResults(container, results, heading) {
    if (!container) return;

    if (!results.length) {
      container.innerHTML = '';
      container.hidden = true;
      container.setAttribute('hidden', '');
      return;
    }

    var isPage = container.id === 'teavity-hub-search-page';
    var html = '';

    if (isPage) {
      var groups = groupResultsByType(results);
      groups.forEach(function (group) {
        html += '<div class="teavity-search-section">';
        html +=
          '<h2 class="teavity-search-section__title">' + escapeHtml(group.label) + '</h2>';
        html += '<div class="teavity-search-grid">';
        group.entries.forEach(function (entry) {
          html += renderSearchCard(entry);
        });
        html += '</div></div>';
      });
    } else if (
      container.id === 'teavity-hub-search-predictive-sidebar' ||
      container.id === 'teavity-hub-search-sidebar'
    ) {
      html = renderSidebarHubSection(results);
    } else if (container.id === 'teavity-hub-search-predictive-main') {
      var hubGroups = groupResultsByType(results);
      hubGroups.forEach(function (group) {
        html += '<div class="teavity-predictive-search__section teavity-hub-search">';
        html +=
          '<h3 class="teavity-search-sidebar-section__title">' +
          escapeHtml(group.label) +
          '</h3>';
        html += '<div class="teavity-search-grid teavity-search-grid--hub">';
        group.entries.forEach(function (entry) {
          html += renderSearchCard(entry);
        });
        html += '</div></div>';
      });
    }

    container.innerHTML = html;
    container.hidden = false;
    container.removeAttribute('hidden');
  }

  function getSearchQuery() {
    var input = document.querySelector(
      '#search-template, #Search-In-Page, .header_search input[name="q"], .search___drawer input[name="q"]'
    );
    return input && input.value ? input.value.trim() : '';
  }

  function hidePredictiveEmptyIfHubs(results) {
    if (!results.length) return;
    var empty = document.querySelector('#search-results-empty');
    if (empty) empty.style.display = 'none';
    var predictive = document.querySelector('#predictive-search');
    if (predictive) predictive.classList.add('results');
  }

  function updatePredictiveSidebarVisibility() {
    var sidebar = document.getElementById('teavity-predictive-search-sidebar');
    if (!sidebar) return;

    var hasLiquidLists = !!sidebar.querySelector(
      '.teavity-predictive-search__section .teavity-search-list'
    );
    var hubSidebar = document.getElementById('teavity-hub-search-predictive-sidebar');
    var hasHealth =
      hubSidebar &&
      !hubSidebar.hasAttribute('hidden') &&
      hubSidebar.innerHTML.trim().length > 0;

    sidebar.hidden = !hasLiquidLists && !hasHealth;

    var body = sidebar.closest('.teavity-predictive-search__body');
    if (body) {
      body.classList.toggle('teavity-predictive-search__body--main-only', sidebar.hidden);
    }
  }

  function injectPredictive() {
    var mainContainer = document.getElementById('teavity-hub-search-predictive-main');
    var sidebarContainer = document.getElementById('teavity-hub-search-predictive-sidebar');
    var query = getSearchQuery();

    if (query.length < 2) {
      if (mainContainer) {
        mainContainer.innerHTML = '';
        mainContainer.hidden = true;
        mainContainer.setAttribute('hidden', '');
      }
      if (sidebarContainer) {
        sidebarContainer.innerHTML = '';
        sidebarContainer.hidden = true;
        sidebarContainer.setAttribute('hidden', '');
      }
      updatePredictiveSidebarVisibility();
      return;
    }

    loadIndex().then(function () {
      var results = searchHubs(query, 6);
      var split = partitionResults(results);

      renderHubResults(mainContainer, split.main, HEADING);
      renderHubResults(sidebarContainer, split.sidebar);

      updatePredictiveSidebarVisibility();
      hidePredictiveEmptyIfHubs(results);
    });
  }

  function patchBlsSearch() {
    if (!window.BlsSearchShopify || window.BlsSearchShopify._teavityHubPatched) return;

    var originalRender = window.BlsSearchShopify.renderSearchResults;
    if (typeof originalRender !== 'function') return;

    window.BlsSearchShopify.renderSearchResults = function (resultsMarkup) {
      originalRender.call(this, resultsMarkup);
      injectPredictive();
    };

    window.BlsSearchShopify._teavityHubPatched = true;
  }

  function getPageSearchQuery() {
    try {
      return new URLSearchParams(window.location.search).get('q') || '';
    } catch (e) {
      return '';
    }
  }

  function initMainSearchPage() {
    if (!/\/search\b/.test(window.location.pathname)) return;

    var mainContainer = document.getElementById('teavity-hub-search-page');
    var sidebarContainer = document.getElementById('teavity-hub-search-sidebar');
    if (!mainContainer) return;

    var query = getPageSearchQuery().trim();
    if (query.length < 2) {
      updateSearchLayout();
      return;
    }

    loadIndex().then(function () {
      var results = searchHubs(query, 24);
      var split = partitionResults(results);

      renderHubResults(mainContainer, split.main, HEADING);

      if (sidebarContainer) {
        var sidebarHtml = renderSidebarHubSection(split.sidebar);
        if (sidebarHtml) {
          sidebarContainer.innerHTML = sidebarHtml;
          sidebarContainer.hidden = false;
          sidebarContainer.removeAttribute('hidden');
        } else {
          sidebarContainer.innerHTML = '';
          sidebarContainer.hidden = true;
          sidebarContainer.setAttribute('hidden', '');
        }
      }

      updateSearchLayout();
    });
  }

  function init() {
    loadIndex();
    patchBlsSearch();
    updateSearchLayout();

    var tries = 0;
    var timer = window.setInterval(function () {
      patchBlsSearch();
      tries += 1;
      if (window.BlsSearchShopify && window.BlsSearchShopify._teavityHubPatched) {
        window.clearInterval(timer);
      }
      if (tries > 50) window.clearInterval(timer);
    }, 100);

    initMainSearchPage();
    updatePredictiveSidebarVisibility();

    document.addEventListener(
      'input',
      function (e) {
        if (!e.target.matches('input[name="q"]')) return;
        if (e.target.id === 'Search-In-Page') return;
        window.clearTimeout(window._teavityHubSearchInputTimer);
        window._teavityHubSearchInputTimer = window.setTimeout(injectPredictive, 200);
      },
      true
    );
  }

  window.TeavityHubSearch = {
    loadIndex: loadIndex,
    searchHubs: searchHubs,
    renderHubResults: renderHubResults,
    injectPredictive: injectPredictive,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
